import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function FireSafety({
  getFireSafetyList,
  fireSafetyList,
  getFireSafetyCalculation,
  fireSafetyCalculation,
  updateCalculationFireSafety,
  ordinanceRevisionId,
}) {
  useEffect(() => {
    getFireSafetyList({
      ordinance_revision_id: ordinanceRevisionId,
    });
    getFireSafetyCalculation();
  }, [ordinanceRevisionId]);

  const handleChange = (e) => {
    const { value } = e.target;
    const payload = { code: value };

    updateCalculationFireSafety(payload, () => {
      getFireSafetyCalculation();
    });
  };

  const checkIsChecked = (code) => {
    if (_.isEmpty(fireSafetyCalculation)) return false;
    const newArr = fireSafetyCalculation.map((i) => {
      const { attributes, ...rest } = i;
      return { ...attributes, ...rest };
    });
    const dataByCode = newArr.find((x) => x.code === code);
    if (!dataByCode || !dataByCode.is_exempted) return false;
    return true;
  };

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body p-3 p-md-4">
        <div className="container-fluid p-0">
          <div className="row d-flex justify-content-center">
            <div className="col-12 text-center mb-3">
              <h3 className="mb-1">Fire Safety Inspection Fees</h3>
              <p className="mb-0 text-muted">
                Enable the toggle to include the fee in the FSIS endorsement.
              </p>
            </div>
          </div>
          <div
            className="table-responsive mt-3"
            style={{ maxHeight: '500px', overflowY: 'auto' }}
          >
            <table className="table table-hover mb-0">
              <thead>
                <tr>
                  <th scope="col" className="border-top-0 px-2 text-uppercase small text-muted">
                    Fire Safety Inspection Fees
                  </th>
                  <th scope="col" className="border-top-0 px-2 text-uppercase small text-muted text-center">
                    Included
                  </th>
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(fireSafetyList) ? (
                  <React.Fragment>
                    {fireSafetyList.map((item) => (
                      <tr key={item.code}>
                        <td className="font-weight-bold py-3 px-2 align-middle">
                          {item.description}
                        </td>
                        <td className="py-3 px-2 text-center align-middle">
                          <div className="custom-control custom-switch d-inline-block mb-0">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`fireSafety-${item.code}`}
                              value={item.code}
                              onChange={handleChange}
                              checked={checkIsChecked(item.code)}
                            />
                            <label className="custom-control-label m-0" htmlFor={`fireSafety-${item.code}`}>
                              <span className="sr-only">{item.description}</span>
                            </label>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan={2} className="text-center text-muted py-4">
                      No fire safety fees found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

FireSafety.propTypes = {
  getFireSafetyList: PropTypes.instanceOf(Function).isRequired,
  fireSafetyList: PropTypes.instanceOf(Object).isRequired,
  getFireSafetyCalculation: PropTypes.instanceOf(Function).isRequired,
  fireSafetyCalculation: PropTypes.instanceOf(Array).isRequired,
  updateCalculationFireSafety: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  fireSafetyList: _.get(api, `${c.GET_FIRE_SAFETY_LIST}.res.fees`) || [],
  fireSafetyCalculation:
    _.get(api, `${c.GET_FIRE_SAFETY_CALCULATION}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FireSafety);
